module.exports = [
  require('./reviver')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/json/index.js
// module id = aXdJ
// module chunks = 0